<template>
  <v-card
    v-if="edocJson"
    class="mb-2"
    outlined
  >
    <v-card-title class="text-body-1 font-weight-bold pb-2">
      <span class="mr-2">{{ $t('eDocInternal.distributeInfo') }}</span>
      <span class="font-weight-light">{{ task.receiveCode }} </span>
    </v-card-title>
    <v-card-text class="black--text">
      <!-- <v-btn-toggle
        v-model="distributeModel"
        mandatory
        borderless
        dense
        class="mb-2"
      >
        <v-btn value="receiver">
          {{ $t('eDocSuggest.history.receiver') }}
        </v-btn>

        <v-btn value="subUnit">
          {{ $t('eDocInternal.distributeInfo.subUnit') }}
        </v-btn>
      </v-btn-toggle> -->

      <template v-if="edocJson && distributeModel === 'receiver'">
        <div v-if="edocJson.isEmpty">
          {{ $t('PublicServant.NoData') }}
        </div>
        <v-chip
          v-for="option in edocJson.options"
          :key="'O' + option.id"
          small
          class="ma-2 ml-0"
        >
          <template v-if="$i18n.locale === 'pt'">
            {{ option.text.pt }}
          </template>
          <template v-else>
            {{ option.text.tc }}
          </template>
        </v-chip>
        <v-chip
          v-if="task.urgentLevelId === 2"
          class="ma-2 ml-0"
          outlined
          small
          color="red"
        >
          {{ $chPtObjData('chinUrgentLevelName', task) }}
        </v-chip>
        <v-tooltip
          top
          color="black"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              v-if="$config.isShowEncrypted && task.securityLevelId > 1"
              small
              outlined
              :color="task.securityLevelId > 2 ? 'purple' : 'info'"
              class="ma-2 ml-0"
              v-bind="attrs"
              v-on="on"
            >
              {{ $chPtObjData('chinSecurityLevelName', task) }}
            </v-chip>
          </template>
          <span>{{ $chPtObjData('chinSecurityLevelName', task) }}</span>
        </v-tooltip>
        <div v-if="edocJson.receiverTOList_detailed">
          <!-- <br v-if="edocJson.receiverTOList_detailed.entity.length"> -->
          <span class="mr-2">{{ $t('eDocSuggest.history.receiver') }}:</span>
          <v-tooltip
            v-for="(group,index) in edocJson.receiverTOList_detailed.g2eEntityGroups"
            :key="group.gid"
            top
            color="black"
          >
            <template v-slot:activator="{ on, attrs }">
              <span
                class="mr-2 mb-2"
                small
                v-bind="attrs"
                v-on="on"
              >
                {{ group.abbr }}
                <span v-if="index < edocJson.receiverTOList_detailed.g2eEntityGroups.length - 1 || edocJson.receiverTOList_detailed.users.length > 0 ">;</span>
              </span>
            </template>
            <span>
              <template v-if="$i18n.locale === 'pt'">
                <span v-if="group.name_pt">{{ group.name_pt }}</span>
                <span v-else>{{ group.name_tc }}</span>
              </template>
              <template v-else>
                <span v-if="group.name_tc">{{ group.name_tc }}</span>
                <span v-else> {{ group.name_pt }} </span>
              </template>
            </span>
          </v-tooltip>
          <v-tooltip
            v-for="(user, index) in edocJson.receiverTOList_detailed.users"
            :key="user.euid"
            top
            color="black"
          >
            <template v-slot:activator="{ on, attrs }">
              <span
                class="mr-2 mb-2"
                small
                v-bind="attrs"
                v-on="on"
              >
                <template v-if="$i18n.locale === 'pt'">
                  <span v-if="user.name_pt">{{ user.name_pt }}; </span>
                  <span v-else>{{ user.name_tc }}; </span>
                </template>
                <template v-else>
                  <span v-if="user.name_tc">{{ user.name_tc }} </span>
                  <span v-else> {{ user.name_pt }} </span>
                </template>
                <span v-if="index < edocJson.receiverTOList_detailed.users.length - 1">;</span>
              </span>
            </template>
            <span>
              {{ user.euid }}
            </span>
          </v-tooltip>
        </div>
      </template>

      <div v-if="assignUnits && distributeModel === 'subUnit'">
        <v-tooltip
          v-for="assignUnit in assignUnits"
          :key="assignUnit.entityId"
          top
          color="black"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              outlined
              class="mr-2 mb-2"
              small
              v-bind="attrs"
              v-on="on"
            >
              {{ assignUnit.abbr }}
            </v-chip>
          </template>
          <span>
            {{ $chPtObjData('chinName', assignUnit) }}
          </span>
        </v-tooltip>
      </div>

      <div>
        <span
          v-if="edocJson.itemAckDate"
          class="mr-2"
        >
          <v-icon color="green lighten-3">{{ mdiClockOutline }}</v-icon> {{ $t('eDocInternal.itemAckDate') }}: {{ moment(edocJson.itemAckDate).format('YYYY-MM-DD HH:mm') }}
        </span>
        <br v-if="this.$vuetify.breakpoint.smAndDown">
        <span v-if="edocJson.expectedReplyDate">
          <v-icon color="red lighten-3">{{ mdiClockOutline }}</v-icon> {{ $t('eDocInternal.expectedReplyDate') }}: {{ moment(edocJson.expectedReplyDate).format('YYYY-MM-DD') }}
        </span>
      </div>

      <template v-if="edocJson">
        <div
          v-if="edocJson.note"
          class="mt-2 my-2"
        >
          <span class="font-weight-black">{{ $t('PublicServant.Obser') }}:</span> {{ edocJson.note }}
        </div>
        <div v-if="task.docTypeId">
          <span class="font-weight-black">{{ $t('eDocSuggest.docType') }}:</span> {{ $chPtObjData('chinDocTypeName', task) }}
        </div>
        <div v-if="task.channelId">
          <span class="font-weight-black">{{ $t('eDocSuggest.channelType') }}:</span> {{ $chPtObjData('chinChannelName', task) }}
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>

// import docFlowApi from '@/api/eDocInternal/docFlow'
import { mdiClockOutline } from '@mdi/js'
import moment from 'moment'

export default {
  components: {
  },
  props: {
    task: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      distributeModel: 'receiver',
      assignUnits: null,
      mdiClockOutline,
      moment
    }
  },
  computed: {
    edocJson () {
      if (!this.task.edocJson) return null
      let temp = JSON.parse(this.task.edocJson)

      temp.isEmpty = (
        (temp.note === null || temp.note === '') &&
        temp.receiverTOList_detailed.users.length === 0 &&
        temp.receiverTOList_detailed.g2eEntityGroups.length === 0 &&
        temp.receiverTOList_detailed.users.length === 0
      )
      return temp
    }
  },
  mounted: function () {
    // this.securityColor = this.task.securityLevelId > 2 ? 'red' : 'info'
    // docFlowApi.getEdocAssignUnit(resp => {
    //   this.assignUnits = resp.data
    // }, this.task.dfInflowId)
  },
  methods: {
  }
}
</script>
